import * as React from 'react'
import { MatchPairProps } from '../../typings'
import { MatchBody } from './MatchBody'
import { NoSelectionBody } from './NoSelectionBody'
import { CreateBody } from './CreateBody'
import { LocationMatch } from '@user/store/entityLocations'

type Props = MatchPairProps & {
  match?: LocationMatch
}

export const RightCard: React.FC<Props> = (props) => {
  const { match, ...rest } = props

  switch (match?.createNewLocation) {
    case undefined:
      return <NoSelectionBody {...rest} />
    case true:
      return <CreateBody {...rest} match={match} />
    case false:
      return <MatchBody {...rest} match={match} />
  }
}
RightCard.displayName = 'RightCard'
